<template>
  <Dropdown class="header-drop" trigger-class="wallet-toggle" dropdown-class="wallet-open">
    <template #trigger>
      <div class="icon-20px icon-mr8 w-embed">
        <WalletIcon />
      </div>
      <div>{{ balance }} ₽</div>
    </template>
    <template>
      <div class="h4 h4-mb4">Пополнение баланса</div>
      <div class="text-secondary ts-mb12">
        Для пополнения баланса свяжитесь с администратором. Оплатить можно по карте или с р/с организации.
      </div>
      <span class="btn-secondary w-inline-block" @click="openJivo">
        Пополнить баланс
      </span>
    </template>
  </Dropdown>
</template>

<script>
  import {mapState, mapActions} from 'vuex';
  import Dropdown from '@/components/Dropdown';
  import WalletIcon from '@/icons/wallet.svg';
  import addSpaces from '@/utils/formatting/add-spaces';

  export default {
    name: 'Balance',
    components: {
      Dropdown,
      WalletIcon,
    },
    computed: mapState({
      user: state => state.auth.user,
      balance () {
        return addSpaces(this.user.balance);
      },
    }),
    methods: mapActions({
      openJivo: 'global/openJivo',
    }),
  };
</script>

<style lang="scss">
  .header-drop {
    .w-dropdown-list {
      right: 0;
      .btn-secondary {
        cursor: pointer;
      }
    }
  }
</style>
